import React, { useState, useEffect } from 'react';
import './supervision.css';
import Events from './events/events';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

// Funktion til at håndtere både markdown og HTML-indhold
const prepareContent = (content) => {
  if (!content) return '';

  // Hvis teksten allerede er HTML (fra rich text editor)
  if (content.includes('<p>') || content.includes('<h') || content.includes('<ul>')) {
    // Vi beholder HTML som den er, da formatering håndteres korrekt i rich text editor
    return content;
  }

  // Hvis det er markdown eller plain text
  // Konverter overskrifter
  let html = content.replace(/^## (.*?)$/gm, '<h3>$1</h3>');

  // Konverter fed tekst
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

  // Konverter bullet points
  html = html.replace(/^- (.*?)$/gm, '<li>$1</li>');
  
  // Del teksten på dobbelte linjeskift, hvilket normalt indikerer nye afsnit
  const paragraphs = html.split(/\n\s*\n/); // Split ved tomme linjer
  html = paragraphs.map(p => {
    const trimmedP = p.trim();
    if (trimmedP === '') return '';
    
    // Håndter lister
    if (trimmedP.includes('<li>')) {
      return `<ul>${trimmedP}</ul>`;
    }
    
    // Håndter overskrifter
    if (trimmedP.includes('<h3>')) {
      return trimmedP;
    }
    
    // Almindelige afsnit - bevar enkelte linjeskift som mellemrum
    return `<p>${trimmedP.replace(/\n/g, ' ')}</p>`;
  }).join('\n\n'); // Tilføj afstand mellem afsnit

  return html;
};

const Supervision = () => {
  const [supervisionData, setSupervisionData] = useState({
    title: '',
    heroImage: '',
    introText: '',
    bottomText: ''
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSupervisionData = async () => {
      try {
        const supervisionDocRef = doc(db, 'content', 'supervision');
        const supervisionDoc = await getDoc(supervisionDocRef);
        
        if (supervisionDoc.exists()) {
          setSupervisionData(supervisionDoc.data());
        }
      } catch (error) {
        console.error('Fejl ved hentning af supervisionsdata:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSupervisionData();
  }, []);

  if (isLoading) {
    return <div className="pp-supervision-loading">Indlæser...</div>;
  }

  return (
    <section className="pp-supervision">
      <div className="pp-supervision__container">
        <h1 className="pp-supervision__title">{supervisionData.title || 'Supervision'}</h1>
        <div className="pp-supervision__image">
          <img src={supervisionData.heroImage || "/media/supervision2.avif"} alt="Supervision" />
        </div>
        
        <div className="pp-supervision__content">
          <div className="pp-supervision__intro-text">
            <div dangerouslySetInnerHTML={{ __html: prepareContent(supervisionData.introText) }} />
          </div>

          <Events />

          {supervisionData.bottomText && (
            <div className="pp-supervision__bottom-text">
              <div dangerouslySetInnerHTML={{ __html: prepareContent(supervisionData.bottomText) }} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Supervision;
